export default "__VITE_ASSET__7041a5fb__"